export { default } from "./getActivityPanelNavigationHref";
